<template>
  <div>
    <el-form class="formBox" :model="editItem" :rules="rules" ref="infoForm" label-width="80px" size="medium" style="text-align: left">
    <el-card class="box-card" v-for="(item,index) in shopList" :key="index">
      <template v-if="editItem&&editItem.serialnum==item.serialnum">
      <div slot="header" class="clearfix">
        <span>{{item.serialnum}}</span>
        <el-button style="float: right; padding: 3px 0;width:60px;height:28px" size="mini" plain @click="cancaleShop(index)">取消</el-button>
        <el-button style="float: right; padding: 3px 0;width:60px;height:28px;margin-right: 8px" size="mini" type="primary" :loading="loading" plain @click="saveShop(item)">保存</el-button>
        <el-button style="float: right; padding: 3px 0;width:60px;height:28px;margin-right: 8px" size="mini" type="danger" :loading="loading" plain @click="delShop(index)">删除</el-button>
      </div>
        <el-form-item label="店名：" prop="dname">
          <el-input v-model="editItem.dname" maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="地址：" prop="province">
          <v-distpicker :province="editItem.province" @province="onChangeProvince" :city="editItem.city"
                        @city="onChangeCity" :area="editItem.county" @area="onChangeArea"></v-distpicker>
        </el-form-item>
        <el-form-item prop="address">
          <el-input v-model="editItem.address" placeholder="详细地址" maxlength="100" show-word-limit ></el-input>
        </el-form-item>
        <el-form-item label="定位">
            <el-input  v-model="editItem.y" size="medium" style="width: 180px">
              <template slot="prepend">经度</template>
            </el-input>
            <el-input  v-model="editItem.x" size="medium" style="width: 180px">
              <template slot="prepend">纬度</template>
            </el-input>
            <el-button size="medium" @click="getLocation">定位</el-button>
       </el-form-item>
        <el-form-item label="营业时间" prop="businesshours">
        <el-input v-model="editItem.businesshours" auto-complete="off" size="medium" placeholder="如 10:00-22:00"></el-input>
      </el-form-item>
        <el-form-item  label="电话：">
          <el-input v-model="editItem.tel" maxlength="20" show-word-limit ></el-input>
        </el-form-item>
      </template>
      <template v-else>
        <div slot="header" class="clearfix">
          <span>{{item.serialnum}}</span>
          <el-button  style="float: right; padding: 3px 0;width:60px;height:28px" size="mini" type="success" plain @click="beginEdit(item)">修改</el-button>
        </div>
        <el-form-item label="店名：">
          {{item.dname}}
        </el-form-item>
        <el-form-item label="地址：">
         {{item.province}}{{item.city}}{{item.county}} {{item.address}}
        </el-form-item>
        <el-form-item  label="时间：">
          {{item.businesshours}}
        </el-form-item>
        <el-form-item  label="电话：">
          {{item.tel}}
        </el-form-item>
      </template>
    </el-card>
    </el-form>
    <el-card class="box-card" v-if="!editItem">
      <div slot="header" class="clearfix" style="min-height: 28px">
        <span>增加门店</span>
      </div>
      <div tabindex="0" class="el-upload el-upload--text" @click="addShop()">
         <i class="el-icon-plus avatar-uploader-icon"></i>
      </div>
    </el-card>
    <Location ref="Location" @afterLocation="afterLocation"></Location>
  </div>
</template>

<script>

  import {listDept, saveDept,updateDept,removeDept} from '@/api/sysmanage/register';
  import Location from '@/components/set/dept/Location';

export default {
  data() {
    return {
      shopList: [],
      loading:false,
      editItem:null,
      copyItem:{},
      rules: {
        dname: [
          { required: true, message: '请输入店名', trigger: 'blur' },
        ],
        province: [{ required: true, message: '请选择地址', trigger: 'blur' }],
        address: [
          { required: true, message: '请填写详细地址', trigger: 'blur' },
        ],
      },
      options: [
        {
          value: 'zhinan',
          label: '中国',
        },
      ],
    }
  },
  methods: {
    onChangeProvince(data) {
      if (data.value == '省') data.value = '';
      this.editItem.province = data.value;
    },
    onChangeCity(data) {
      if (data.value == '市') data.value = '';
      this.editItem.city = data.value;
    },
    onChangeArea(data) {
      if (data.value == '区' || data.value == '县') data.value = '';
      this.editItem.county = data.value;
    },
    beginEdit(item) {
      this.editItem = item;
      this.copyItem = {}
      for (let key in item) {
        this.copyItem[key] = item[key];
      }
    },
    cancaleShop(index) {
      if (this.editItem.serialnum) {
        for (let key in this.copyItem) {
          this.editItem[key] = this.copyItem[key];
        }
        this.editItem = null;
      } else {
        this.shopList.splice(index, 1);
        this.editItem=null;
      }
    },
    //定位
    getLocation(){
      if(!this.editItem.address||!this.editItem.province||!this.editItem.city||!this.editItem.county){
        this.$message({
          message: '请先填写完整地址！',
          type: 'error'
        })
        return;
      }
      this.$refs.Location.show(this.editItem.y,this.editItem.x,this.editItem.province+this.editItem.city+this.editItem.county+this.editItem.address);
    },
    //定位后
    afterLocation(y,x){
      this.editItem.y=y;
      this.editItem.x=x;
    },
    delShop(index) {
      this.$confirm('是否确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          if (this.editItem.serialnum) {
            this.loading = true;
            removeDept({serialnum:this.editItem.serialnum}).then(response => {
              if (response.data.code === 0) {
                this.editItem=null;
                this.shopList.splice(index, 1);
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                })
              }
              this.loading = false;
            });
          }else{
            this.editItem=null;
          }
        })
    },
    saveShop() {
      if (!this.editItem)
        return;

      this.$refs.infoForm.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.editItem.serialnum) {
            updateDept(this.editItem).then(response=>{
              if (response.data.code === 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                this.editItem=null;
                //this.bindTable();
              }else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                })
              }
              this.loading = false;
            })
          } else {
            saveDept(this.editItem).then(response=>{
              if (response.data.code === 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                this.bindTable();
              }else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                })
              }
              this.loading = false;
            })
          }
        } else {
          return false;
        }
      });
    },
    addShop() {
      let shopForm = {
        dname: '',
        address: '',
        county: '',
        city: '',
        province: '',
        tel: '',
        unitguid: '',
        serialnum: '',
        parentdserial:'0001',
        independent:'1',
        customerserial:'',
        leaduguid:'',
        dsortnum:0,
        x:'',
        y:'',
        businesshours:''
      }
      this.editItem=shopForm;
      this.shopList.push(shopForm);
    },
    prevFn() {

    },
    finishFn(callback) {
      if (this.editItem) {
        this.$message({
          message: '存在编辑状态中的门店信息，请保存后再进入下一步！',
          type: 'error'
        })
        callback(false);
      } else {
        callback(true);
      }
    },
    bindTable(){
      this.editItem=null;
      listDept().then(response => {
        if (response.data.code == 0) {//有数据返回的
          this.shopList=response.data.obj;
        }
      });
    }
  },
  components:{
    Location
  },
  mounted() {//第一次加载，取公司信息
    this.bindTable();
  },
}
</script>

<style scoped>

  .box-card {
    width: 580px;
    float: left;
    margin-left: 10px;
    margin-bottom: 15px;
    min-height: 280px;
  }
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .clearfix span{
    float:left;
    font-weight:600;
    font-size:14px;
  }

  .el-upload {
    display: inline-block;
    text-align: center;
    cursor: pointer;
    outline: none;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 160px;
    height: 160px;
    line-height: 160px;
    text-align: center;
  }

  .el-upload:hover {
    border-color: #409EFF;
  }
</style>



// WEBPACK FOOTER //
// src/views/childComp/ShopInfo.vue